module.exports = __webpack_public_path__ + "static/favicon-6aeed0b1cd9d927ae74adbf5a8577f42.png";